module.exports = __webpack_public_path__ + "img/howtouse02.aebd8aa6.jpg";